<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import * as index from './api/index.js'
	export default {
		name: 'App',
		data() {
			return {
				page: {
					pageNo: 1,
					pageSize: 10,
					total: 0
				},
			}
		},
		methods: {
			setRootFontSize() {
				let rem, rootWidth;
				let rootHtml = document.documentElement;
				//限制展现页面的最小宽度
				rootWidth = rootHtml.clientWidth < 1366 ? 1366 : rootHtml.clientWidth;
				// 19.2 = 设计图尺寸宽 / 100（ 设计图的rem = 100 ）
				rem = rootWidth / 10;
				// 动态写入样式
				rootHtml.style.fontSize = `${rem}px`;
			},
			getOptions(type) {
				let data = {
					type : type
				}
				index.getOptions(this, data)
					.then((res) => {
						if (res.success) {
							if(type == 1){
								this.$store.state.groupList = res.data
							}else{
								this.$store.state.companyList = res.data
							}
						} else {
							this.$message.warning(res.info)
						}
					})
					.catch((res) => {
						this.loading = false;
						console.log('fail');
					})
			}
		},
		mounted() {
			this.setRootFontSize()
		}
	}
</script>
<style>
	#app {
		font-size: 0.067708rem;
		line-height: 1;
		font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\5FAE\8F6F\96C5\9ED1,Arial,sans-serif;
	}

	.content {
		font-size: 0.067708rem;
		height: calc(100vh - 0.670833rem);
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
